import { render, staticRenderFns } from "./imageItemForDetected.vue?vue&type=template&id=493f14ea&scoped=true&"
import script from "./imageItemForDetected.vue?vue&type=script&lang=js&"
export * from "./imageItemForDetected.vue?vue&type=script&lang=js&"
import style0 from "./imageItemForDetected.vue?vue&type=style&index=0&id=493f14ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f14ea",
  null
  
)

export default component.exports